import { render, staticRenderFns } from "./ManageOrg.vue?vue&type=template&id=5b212eb3"
import script from "./ManageOrg.vue?vue&type=script&lang=js"
export * from "./ManageOrg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports